import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";
import { TextIcon } from "../../../choir/pages/dashboard/Choir/ChoirUpperRow/styles";

export const StyledUpperRow = styled.div<IStyleProps>`
    ${p =>
        p.theme.sm.min(css`
            display: flex;
        `)}
    ${p =>
        p.isCovid
            ? css`
                  display: flex;
              `
            : p.theme.xs(css`
                  margin-bottom: 12px;
              `)}
`;

export const LeftTop = styled.div`
    display: inline-block;
`;

export const RightTop = styled.div<IStyleProps>`
    flex: 1;
    justify-content: flex-end;
    padding-right: 9px;
    display: flex;
    ${p =>
        !p.isCovid &&
        p.theme.xs(css`
            position: fixed;
            z-index: 11;
            bottom: 10px;
            left: 7px;
        `)}
    ${p =>
        p.isCovid && css`
            padding-top: 12px;
        `}
    ${p =>
        p.theme.withNotch(css`
            padding-bottom: calc(env(safe-area-inset-bottom) / 2);
        `)}
`;

export const UpperBtn = styled.div`
    display: inline-flex;
    width: 50px;
    border-radius: 40px;
    transition: 300ms;
    position: relative;
    z-index: 1;
    justify-content: center;
    &:hover {
        transform: scale(1.14);
    }
    svg,
    [class^="i-"],
    ${TextIcon} {
        fill: ${p => p.theme.c.active};
        color: ${p => p.theme.c.active};
        width: 36px;
        height: 36px;
        font-size: 36px;
        display: block;
    }

    .QuickButtonDisabled {
        pointer-events: none;
        svg,
        [class^="i-"] {
            fill: ${p => p.theme.c.disabled};
            color: ${p => p.theme.c.disabled};
        }
    }
`;

export const Alert = styled.div`
    position: absolute;
    bottom: 0;
    right: -2px;
    background-color: ${p => p.theme.c.info};
    width: 14px;
    height: 14px;
    font-size: 11px;
    border-radius: 7px;
    text-align: center;
    color: ${p => p.theme.c.whiteOnActive};
`;

export const Center = styled.div`
    text-align: center;
`;

export const BelowBreadcrumbAdSense = styled.div`
    height: 100px;
    display: flex;
    justify-content: center;
    margin: 12px -20px 20px;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const CovidHint = styled.div`
    line-height: 30px;
    font-size: 22px;
    margin-top: 8px;
    .i-arrowback {
        font-size: 32px;
        display: inline-block;
        transform: scale(-1, 1) translateY(6px);
        color: ${p => p.theme.c.black};
    }
`;
